export default __webpack_public_path__ + "static/media/tallify-inventory-sync.31677bed.png";